import { Restore, Check } from "@mui/icons-material";
import { Button, Tab, Tabs } from "@mui/material";
import { useState } from "react";
// import { ReactGrid } from "@silevis/reactgrid";
import ReactGrid from "../ReactGridComponent";
import { useTheme } from "@mui/styles";

const headerRow = {
  rowId: "header",
  cells: [
    { type: "header", text: "Measured Depth (m)" },
    { type: "header", text: "Inclination (deg)" },
    { type: "header", text: "Azimuth" },
    { type: "header", text: "TVD (m)" }
  ]
};

const getColumns = () => [
  { columnId: "measuredDepth", width: 150 },
  { columnId: "inclination", width: 150 },
  { columnId: "azimuth", width: 150 },
  { columnId: "trueVerticalDepth", width: 150 }
];

export const RTFOPadSurveys = ({ wells, surveys, setSurveys, darkMode }) => {

  const theme = useTheme();
  const wellNames = wells?.map(well => well.name);

  const [tabItem, setTabItem] = useState(0);
  const [isModified, setIsModified] = useState(true);

  const [data, setData] = useState(() => {
    const rows = [];

    for (let i = 0; i < 1000; i++) {
      rows.push({
        measuredDepth: surveys?.wells?.[wellNames?.[tabItem]]?.surveyData?.[i]?.measuredDepth >= 0 ? surveys?.wells?.[wellNames?.[tabItem]]?.surveyData?.[i]?.measuredDepth : null,
        inclination: surveys?.wells?.[wellNames?.[tabItem]]?.surveyData?.[i]?.deviation >= 0 ? surveys?.wells?.[wellNames?.[tabItem]]?.surveyData?.[i]?.deviation : null,
        azimuth: surveys?.wells?.[wellNames?.[tabItem]]?.surveyData?.[i]?.direction >= 0 ? surveys?.wells?.[wellNames?.[tabItem]]?.surveyData?.[i]?.direction : null,
        trueVerticalDepth: surveys?.wells?.[wellNames?.[tabItem]]?.surveyData?.[i]?.trueVerticalDepth >= 0 ? surveys?.wells?.[wellNames?.[tabItem]]?.surveyData?.[i]?.trueVerticalDepth : null
      });
    };

    return rows;
  });

  const getRows = (data) => [
    headerRow,
    ...data.map((row, idx) => ({
      rowId: idx,
      cells: [
        { type: "number", value: row.measuredDepth },
        { type: "number", value: row.inclination },
        { type: "number", value: row.azimuth },
        { type: "number", value: row.trueVerticalDepth }
      ]
    }))
  ];

  const rows = getRows(data);
  const columns = getColumns();

  const applyChangesToData = (changes, prevData) => {
    changes.forEach((change) => {
      const dataIndex = change.rowId;
      const fieldName = change.columnId;
      prevData[dataIndex][fieldName] = change.newCell.value;
    });
    return [...prevData];
  };

  const handleChanges = (changes) => {
    setData((prevData) => applyChangesToData(changes, prevData));
    setIsModified(true);
  };

  try {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%', position: 'relative', overflow: 'hidden' }}>
        <div>
          <Tabs
            value={tabItem}
            onChange={(e, value) => handleTabChange(value)}
            style={{ borderBottom: '1px solid lightgrey', marginBottom: 20 }}
            textColor={darkMode ? "inherit" : "primary"}
            TabIndicatorProps={{ style: { background: (darkMode ? '#fff' : theme?.palette?.primary?.main) } }}
          >
            {wells?.map(well => {
              return (<Tab label={well.name} key={well.uwi || well.name} />)
            })}
          </Tabs>

          <div style={{ marginBottom: 20 }}>
            <Button
              variant="contained"
              size="small"
              startIcon={<Check />}
              onClick={handleSaveClick}
              style={{ marginRight: 20, color: darkMode ? '#000' : '#fff', backgroundColor: darkMode ? "#fff" : theme.palette.primary.main }}
              disabled={!isModified}
            >
              Save Survey</Button>
            <Button variant="outlined"
              size="small"
              startIcon={<Restore />}
              onClick={handleResetClick}
              style={{
                color: (darkMode ? '#fff' : theme.palette.primary.main),
                borderColor: (darkMode ? '#fff' : theme.palette.primary.main)
              }}
            >
              Reset
            </Button>
          </div>
          <ReactGrid
            divProps={{
              style: {
                maxHeight: 900,
                overflow: "scroll"
              }
            }}
            rows={rows}
            columns={columns}
            onCellsChanged={handleChanges}
            enableRangeSelection
            enableFillHandle
            stickyTopRows={1}
          />
        </div>
      </div>
    );
  } catch (error) {
    console.log(error);
    return <></>;
  };

  function handleTabChange(newTabItem) {
    try {
      if (newTabItem >= 0) {
        setTabItem(newTabItem)

        const rows = [];

        for (let i = 0; i < 1000; i++) {
          rows.push({
            measuredDepth: surveys?.wells?.[wellNames?.[newTabItem]]?.surveyData?.[i]?.measuredDepth >= 0 ? surveys?.wells?.[wellNames?.[newTabItem]]?.surveyData?.[i]?.measuredDepth : null,
            inclination: surveys?.wells?.[wellNames?.[newTabItem]]?.surveyData?.[i]?.deviation >= 0 ? surveys?.wells?.[wellNames?.[newTabItem]]?.surveyData?.[i]?.deviation : null,
            azimuth: surveys?.wells?.[wellNames?.[newTabItem]]?.surveyData?.[i]?.direction >= 0 ? surveys?.wells?.[wellNames?.[newTabItem]]?.surveyData?.[i]?.direction : null,
            trueVerticalDepth: surveys?.wells?.[wellNames?.[newTabItem]]?.surveyData?.[i]?.trueVerticalDepth >= 0 ? surveys?.wells?.[wellNames?.[newTabItem]]?.surveyData?.[i]?.trueVerticalDepth : null
          });
        };

        setData(() => rows);
        setIsModified(false);
      };

    } catch (error) {
      console.log(error);
      return;
    };
  };

  function handleSaveClick() {
    try {
      const wellSurvey = [];

      for (let i = 0; i < data?.length; i++) {
        const row = data[i];

        if (Number(row?.measuredDepth) > 0) {
          wellSurvey.push({
            measuredDepth: Number(row?.measuredDepth) >= 0 ? Number(row?.measuredDepth) : null,
            deviation: Number(row?.inclination) >= 0 ? Number(row?.inclination) : null,
            direction: Number(row?.azimuth) >= 0 ? Number(row?.azimuth) : null,
            trueVerticalDepth: Number(row?.trueVerticalDepth) >= 0 ? Number(row?.trueVerticalDepth) : null
          });
        };
      };

      const newSurveys = JSON.parse(JSON.stringify(surveys));
      newSurveys.wells[wellNames?.[tabItem]].surveyData = wellSurvey;
      setSurveys(() => newSurveys);

      setIsModified(false);

    } catch (error) {
      console.log(error);
    };
  };

  function handleResetClick() {
    try {
      const rows = [];

      for (let i = 0; i < 1000; i++) {
        rows.push({
          measuredDepth: surveys?.wells?.[wellNames?.[tabItem]]?.surveyData?.[i]?.measuredDepth >= 0 ? surveys?.wells?.[wellNames?.[tabItem]]?.surveyData?.[i]?.measuredDepth : null,
          inclination: surveys?.wells?.[wellNames?.[tabItem]]?.surveyData?.[i]?.deviation >= 0 ? surveys?.wells?.[wellNames?.[tabItem]]?.surveyData?.[i]?.deviation : null,
          azimuth: surveys?.wells?.[wellNames?.[tabItem]]?.surveyData?.[i]?.direction >= 0 ? surveys?.wells?.[wellNames?.[tabItem]]?.surveyData?.[i]?.direction : null,
          trueVerticalDepth: surveys?.wells?.[wellNames?.[tabItem]]?.surveyData?.[i]?.trueVerticalDepth >= 0 ? surveys?.wells?.[wellNames?.[tabItem]]?.surveyData?.[i]?.trueVerticalDepth : null
        });
      };

      setData(() => rows);

      setIsModified(false);

    } catch (error) {
      console.log(error);
      return;
    };
  };
};
